import { Content } from "@/ui";
import { createTitle } from "@/functions/createTitle";
import { getRoute } from "@/functions/getRoute";
import { services_helper } from "@/helpers/services_helper";

export default function ServicesPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const title = "Our Services";
  const services = services_helper.fetch({ filter: (i) => !!i.page });

  return {
    props: {
      meta: {
        title: createTitle(title),
      },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Employers", href: getRoute("employers") },
              { label: title, href: getRoute("services") },
            ],
          },
        },
        {
          component: "Header",
          props: {
            title: {
              path: `page.services.component.Header.title`,
              placeholder: title,
            },
            description: {
              path: `page.services.component.Header.description`,
            },
            img: {
              path: `page.services.component.Header.img`,
            },
          },
        },
        {
          component: "GridButtonsGrid",
          props: {
            title: {
              path: `page.services.component.GridButtonsGrid.title`,
              placeholder: title,
            },
            items: services.map((i) => ({
              title: i.title,
              img: i.icon_image ?? null,
              href: i.page ? getRoute("servicePage", { url_slug: i.url_slug }) : null,
            })),
          },
        },
        ...services.map((i, k) => ({
          component: "NarrativePanel",
          props: {
            className: k % 2 === 0 ? "bg-light py-4 py-md-5" : "bg-white py-4 py-md-5",
            title: i.title,
            description: i.description,
            img: i.card_image ?? null,
            reverse: k % 2 === 0,
            cta: {
              label: "Discover more",
              href: getRoute("servicePage", { url_slug: i.url_slug }),
              variant: "quaternary",
            },
          },
        })),
        {
          component: "Form",
          props: {
            className: "bg-light py-4 py-md-5",
            formId: "a7c90e4b-38ed-43c1-815f-34d1f30a562a",
          },
        },
      ],
    },
  };
}
